module.exports = __webpack_public_path__ + "img/dell.8d90005a.svg";